'use client'

import { type ComponentType, useEffect, useState } from 'react'

type AnalyticsModules = {
  Analytics: ComponentType
  SpeedInsights: ComponentType
}

const analyticsEnabled = process.env.NEXT_PUBLIC_ENABLE_PERFORMANCE_ANALYTICS === 'true'

export function DeferredAnalytics() {
  const [modules, setModules] = useState<AnalyticsModules | null>(null)

  useEffect(() => {
    if (!analyticsEnabled) {
      return
    }

    let cancelled = false

    const loadAnalytics = () => {
      void Promise.all([import('@vercel/analytics/react'), import('@vercel/speed-insights/next')]).then(
        ([analyticsModule, speedInsightsModule]) => {
          if (cancelled) {
            return
          }

          setModules({
            Analytics: analyticsModule.Analytics,
            SpeedInsights: speedInsightsModule.SpeedInsights,
          })
        },
      )
    }

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(loadAnalytics, { timeout: 6000 })

      return () => {
        cancelled = true
        window.cancelIdleCallback(idleId)
      }
    }

    const timeoutId = globalThis.setTimeout(loadAnalytics, 3500)

    return () => {
      cancelled = true
      globalThis.clearTimeout(timeoutId)
    }
  }, [])

  if (!modules) {
    return null
  }

  const { Analytics, SpeedInsights } = modules

  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  )
}
